export const trainingSchedule = [
  {
    id: 1,
    startDate: "19 Jan",
    endDate: "24 Jan",
    month: "Januari",
    material: "Business & Analytical Thinking"
  },
  {
    id: 2,
    startDate: "26 Jan",
    endDate: "31 Jan",
    month: "Januari",
    material: "Excel for Data Cleaning"
  },
  {
    id: 3,
    startDate: "02 Feb",
    endDate: "07 Feb",
    month: "Februari",
    material: "Excel for Data Analysis"
  },
  {
    id: 4,
    startDate: "9 Feb",
    endDate: "14 Feb",
    month: "Februari",
    material: "SQL for Data Analyst"
  },
  {
    id: 5,
    startDate: "18 Feb",
    endDate: "21 Feb",
    month: "Februari",
    material: "Python for Data Analysis"
  },
  {
    id: 6,
    startDate: "23 Feb",
    endDate: "28 Feb",
    month: "Februari",
    material: "Data Visualization & Storytelling"
  },
  {
    id: 7,
    startDate: "02 Mar",
    endDate: "07 Mar",
    month: "Maret",
    material: "Google Sheets Fundamentals"
  },
  {
    id: 8,
    startDate: "9 Mar",
    endDate: "14 Mar",
    month: "Maret",
    material: "Data Analysis with Google Sheets"
  },
  {
    id: 9,
    startDate: "31 Mar",
    endDate: "04 Apr",
    month: "April",
    material: "Data Visualization with Google Sheets"
  },
  {
    id: 10,
    startDate: "06 Apr",
    endDate: "11 Apr",
    month: "April",
    material: "Reporting with Google Docs"
  },
  {
    id: 11,
    startDate: "13 Apr",
    endDate: "18 Apr",
    month: "April",
    material: "Presentation with Google Slides"
  },
  {
    id: 12,
    startDate: "20 Apr",
    endDate: "25 Apr",
    month: "April",
    material: "Excel for Data Cleaning"
  },
  {
    id: 13,
    startDate: "27 Apr",
    endDate: "30 Apr",
    month: "April",
    material: "Excel for Data Analysis"
  },
  {
    id: 14,
    startDate: "04 May",
    endDate: "09 May",
    month: "Mei",
    material: "SQL for Data Analyst"
  },
  {
    id: 15,
    startDate: "11 May",
    endDate: "13 May",
    month: "Mei",
    material: "Python for Data Analysis"
  },
  {
    id: 16,
    startDate: "18 May",
    endDate: "23 May",
    month: "Mei",
    material: "Statistics for Data Science"
  },
  {
    id: 17,
    startDate: "25 May",
    endDate: "30 May",
    month: "Mei",
    material: "Probability & Hypothesis Testing"
  },
  {
    id: 18,
    startDate: "2 Jun",
    endDate: "6 Jun",
    month: "Juni",
    material: "Regression Analysis"
  },
  {
    id: 19,
    startDate: "8 Jun",
    endDate: "13 Jun",
    month: "Juni",
    material: "Machine Learning Fundamentals"
  },
  {
    id: 20,
    startDate: "15 Jun",
    endDate: "20 Jun",
    month: "Juni",
    material: "Model Evaluation"
  },
  {
    id: 21,
    startDate: "22 Jun",
    endDate: "27 Jun",
    month: "Juni",
    material: "Feature Engineering"
  }
];
